export const DISCOUNT_MILESTONE_OFFSETS = {
  desktop: {
    x: 30,
    y: 8,
  },
  mobile: {
    x: 30,
    y: 8,
  },
};
